// extracted by mini-css-extract-plugin
export default {"center":"AdminForm_center__7uXL2","bold":"AdminForm_bold__ImsyV","permissionRow":"AdminForm_permissionRow__9Fi3T","permissionLabel":"AdminForm_permissionLabel__ku9T6"};